var render = function render(){var _vm=this,_c=_vm._self._c;return _c('portal',{attrs:{"to":"root"}},[(_vm.isOpen)?_c('div',{class:[
      _vm.$style.PWCropper,
      'pw-cropper'
    ]},[_c('div',{class:_vm.$style.PWCropperCtx},[_c('section',{class:_vm.$style.PWCropperBody},[_c('Cropper',{ref:"cropper",attrs:{"src":_vm.src,"resize-image":{
            adjustStencil: false,
          },"stencil-props":{
            movable: false,
            resizable: false,
            aspectRatio: _vm.aspectRatio,
            handlers: {},
            lines: {},
          },"image-restriction":"stencil"},on:{"ready":_vm.handleReady}})],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isLoaded),expression:"isLoaded"}],class:_vm.$style.PWCropperFooter},[_c('PWButton',{attrs:{"variant":"outline","size":"medium"},on:{"click":_vm.handleClose}},[_vm._v("\n          Сбросить\n        ")]),_vm._v(" "),_c('PWButton',{attrs:{"size":"medium"},on:{"click":_vm.handleSave}},[_vm._v("\n          Сохранить\n        ")])],1)])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }